import { render, staticRenderFns } from "./ConnectCarrier.vue?vue&type=template&id=5f88a4f8&"
import script from "./ConnectCarrier.vue?vue&type=script&lang=js&"
export * from "./ConnectCarrier.vue?vue&type=script&lang=js&"
import style0 from "./ConnectCarrier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports